import { FC } from 'react';

import { adaptQuotationNewModelDto } from '@savgroup-front-common/core/components/Quotation/adapters/adaptQuotationNewModelDto';
import { StatelessQuotationTotal } from '@savgroup-front-common/core/components/Quotation/StatelessQuotationTotal/StatelessQuotationTotal';

import { useCalculateQuotationTotals } from './useCalculateQuotationTotals';

interface QuotationTotalProps {
  quotation: ReturnType<typeof adaptQuotationNewModelDto>[0];
  fileId: string;
}

const QuotationTotal: FC<QuotationTotalProps> = ({ quotation, fileId }) => {
  const {
    alreadyPaid,
    totalAmountToBePaid,
    totalDiscountIncludedTax,
    subtotalPreVat,
    subtotalVat,
    bonus,
  } = useCalculateQuotationTotals({ quotation, fileId });

  return (
    <StatelessQuotationTotal
      alreadyPaid={alreadyPaid}
      bonus={bonus}
      subtotalPreVat={subtotalPreVat}
      subtotalVat={subtotalVat}
      totalAmountToBePaid={totalAmountToBePaid}
      totalDiscountIncludedTax={totalDiscountIncludedTax}
    />
  );
};

export default QuotationTotal;
